"use client";

import { Program, StandardLP } from "@/services/types";
import { useEffect, useState } from "react";
import { Mousewheel, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import SlideWorkshop from "./SlideWorkshop";
import SliderArrows from "../SliderArrows";
function SliderWorkshop({
  subCategories,
  programs
}: {
  subCategories: Program[];
  programs: StandardLP[];
}) {
  const [isMobile, setIsMobile] = useState(typeof window !== "undefined" ? window.innerWidth < 992 : false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 992);
      };
      window.addEventListener("resize", handleResize);

      // Cleanup the event listener on component unmount
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, []);
  const [showAll, setShowAll] = useState(false);
  const visibleLearners = showAll || !isMobile ? subCategories : subCategories?.slice(0, 4);
  const swiperSettings = {
    spaceBetween: 32,
    breakpoints: {
      0: {
        spaceBetween: 10
      },
      768: {
        spaceBetween: 20
      },
      1024: {
        spaceBetween: 30
      }
    },
    navigation: {
      prevEl: ".section__programs-arrow-prev--card",
      nextEl: ".section__programs-arrow-next--card"
    }
  };
  return <div className="section__programs-slider-container " data-sentry-component="SliderWorkshop" data-sentry-source-file="index.tsx">
      <div className="section__programs-slider-header section__container--small">
        <div className="alternative_header">
          <p className="alternative_header-caption">
            Focused, Hands-On Learning
          </p>
          <h2>Workshops</h2>
          <p className="alternative_header-description">
            Enhance your skills with our intensive Workshops, offering focused
            sessions and practical exercises. Benefit from immediate, hands-on
            experience.
          </p>
        </div>
        <div className="section__programs-arrows">
          <SliderArrows slidesLength={visibleLearners?.length} prevButtonClassName={swiperSettings.navigation.prevEl} nextButtonClassName={swiperSettings.navigation.nextEl} data-sentry-element="SliderArrows" data-sentry-source-file="index.tsx" />
        </div>
      </div>
      <div className="section__programs-slider">
        <Swiper className="section__programs-slider-swiper swiper-learners" {...swiperSettings} modules={[Navigation, Mousewheel]} slidesPerView={"auto"} mousewheel={{
        eventsTarget: ".swiper-learners",
        forceToAxis: true
      }} data-sentry-element="Swiper" data-sentry-source-file="index.tsx">
          {visibleLearners?.map((learner, index) => <SwiperSlide key={index}>
              <SlideWorkshop learner={learner} program={programs.find(p => Number(p.attributes.productId) === learner.product_id) || programs[0]} />
            </SwiperSlide>)}
        </Swiper>
        <div className="section__programs-slider-swiper-mobile">
          {visibleLearners?.map((learner, index) => <SlideWorkshop learner={learner} key={index} program={programs.find(p => Number(p.attributes.productId) === learner.product_id) || programs[0]} />)}
        </div>
        {!showAll && subCategories?.length > 4 && <button onClick={() => setShowAll(true)} className="section__programs-slider-swiper-button">
            See More
          </button>}
      </div>
    </div>;
}
export default SliderWorkshop;